module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/300.128cee57.png";